import { memo } from "react";
import styled from "styled-components";
import { UI_Header, UI_HeaderLeft, UI_HeaderRight, UI_HeaderRight_item } from "../PanelStyle";
import { FaXmark } from "react-icons/fa6";
import { PiCompassBold } from "react-icons/pi";
import { useAtom } from 'jotai';
import { showNavigatorPanelAtom } from "../../stores/mapStore";
import { showDataTableAtom } from "../../stores/mapStore";
import { showCommentPanelAtom } from "../../stores/mapStore";
import { showLegendPanelAtom } from "../../stores/mapStore";
import { showGeocollectPanelAtom } from "../../stores/mapStore";
import { showForestWatchPanelAtom } from "../../stores/mapStore";
import { showUploadTaskPanelAtom } from "../../stores/mapStore";
import { Button } from "antd";
import keyboardShortcutGuide from './keyboard_shortcut_guide.png'

export const NavigatorPanel = () => {
  const [showNavigatorPanel, setShowNavigatorPanel] = useAtom(showNavigatorPanelAtom);
  const [showDataTablePanel, setShowDataTablePanel] = useAtom(showDataTableAtom);
  const [showCommentPanel, setShowCommentPanel] = useAtom<boolean>(showCommentPanelAtom);
  const [showLegendPanel, setShowLegendPanel] = useAtom<boolean>(showLegendPanelAtom);
  const [showGeocollectPanel, setShowGeocollectPanel] = useAtom<boolean>(showGeocollectPanelAtom);
  const [showForestWatchPanel, setShowForestWatchPanel] = useAtom<boolean>(showForestWatchPanelAtom);
  const [showUploadTaskPanel, setShowUploadTaskPanel] = useAtom<boolean>(showUploadTaskPanelAtom);

  return <UI_Wrapper>
    <UI_Header>
      <UI_HeaderLeft style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <PiCompassBold style={{ color: '#2563eb', fontSize: '18px' }} />
        <span>Hướng dẫn và điều hướng</span>
      </UI_HeaderLeft>
      <UI_HeaderRight>
        <UI_HeaderRight_item onClick={() => setShowNavigatorPanel(!showNavigatorPanel)}>
          <FaXmark />
        </UI_HeaderRight_item>
      </UI_HeaderRight>
    </UI_Header>
    <UI_Content>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        <div>Hãy giữ Ctrl + K sau đó giữ Ctrl + (lệnh bạn muốn) </div>
        <img style={{ width: '100%', maxWidth: 1080 }} src={keyboardShortcutGuide} />
        <UI_Group>
          <UI_Group_Header> Dữ liệu và bản đồ: </UI_Group_Header>
          <UI_Group_Content>
            <ul>
              <li>Chú giải: Hiển thị chú giải, thông tin của các lớp bản đồ <Button onClick={() => setShowLegendPanel(!showLegendPanel)}>Hiển thị chú giải</Button></li>
              <li>Bảng dữ liệu: Hiển thị dữ liệu dạng bảng <Button onClick={() => setShowDataTablePanel(!showDataTablePanel)}>Bảng dữ liệu</Button></li>
              <li>Upload dữ liệu: Tải lên dữ liệu bất kỳ, kéo thả file vào bản đồ <Button onClick={() => setShowUploadTaskPanel(!showUploadTaskPanel)}>Upload dữ liệu</Button></li>
              <li>Danh sách tải lên: Xem danh sách dữ liệu đã tải lên <Button onClick={() => setShowUploadTaskPanel(!showUploadTaskPanel)}>Danh sách tải lên</Button></li>
            </ul>
          </UI_Group_Content>
        </UI_Group>
        <UI_Group>
          <UI_Group_Header> Bảng ghi chú: </UI_Group_Header>
          <UI_Group_Content>
            Đánh dấu ghi chú, thảo luận lên bản đồ <Button onClick={() => setShowCommentPanel(!showCommentPanel)}>Mở bảng ghi chú</Button>
          </UI_Group_Content>
        </UI_Group>
        <UI_Group>
          <UI_Group_Header> Geocollect (thu thập): </UI_Group_Header>
          <UI_Group_Content>
            Quản lý dữ liệu thu thập, đội nhóm từ phần mềm Geocollect mobile <Button onClick={() => setShowGeocollectPanel(!showGeocollectPanel)}>Mở bảng thu thập</Button>
          </UI_Group_Content>
        </UI_Group>
        <UI_Group>
          <UI_Group_Header> Ảnh vệ tinh và cháy rừng: </UI_Group_Header>
          <UI_Group_Content>
            Ảnh vệ tinh, cháy rừng, theo dõi biến động <Button onClick={() => setShowForestWatchPanel(!showForestWatchPanel)}>Mở bảng ảnh vệ tinh & cháy rừng</Button>
          </UI_Group_Content>
        </UI_Group>
      </div>
    </UI_Content>
  </UI_Wrapper >
};

export default memo(NavigatorPanel);

const UI_Wrapper = styled.div`
  position: absolute;
  width: 80vw;
  height: 80vh;
  top: 50%;
  left: 50%;
  border-radius: 16px;
  transform: translate(-50%, -50%);
  background-color: rgba(255,255,255, 0.8);
  backdrop-filter: blur(10px);
  box-shadow: var(--shadows-paneShadow);
  z-index: 9999;
`;

const UI_Content = styled.div`
  padding: 16px;
  height: calc(100% - 50px);
  overflow-y: auto;
`;

const UI_Group = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const UI_Group_Header = styled.div`
`
const UI_Group_Content = styled.div`
  color: #666;
  padding: 16px;
`